import { render, staticRenderFns } from "./file-controller.vue?vue&type=template&id=556da9e2&scoped=true&"
import script from "./file-controller.vue?vue&type=script&lang=js&"
export * from "./file-controller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556da9e2",
  null
  
)

export default component.exports